import { Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { TraceServiceImprovement } from 'app/trace-management/core/services/trace-improvement.service';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent {
  @ViewChild('contentDiv') contentDiv!: ElementRef;
  public isOverflowingX = false;
  public textWrap = false;
  public blockSize: number = 102400;
  public contentFile: string = '';
  public contentSize: string = '';
  public screenHeightStyle: string = '';
  public showLoading: boolean = false;
  public isDownloading: boolean = false;
  public showLoadMoreResults: boolean = false;
  public loadingMessage: string = '';
  public sizeDisplayed: number = 0;
  public contentFilter: IContentFilter = { BlobName: '', Start: 0, End: this.blockSize };

  constructor(@Inject(BZG_MODAL_DATA) public trace, private _traceService: TraceServiceImprovement, public modalComponentRef: BzgModalRef, private _i18nService: I18nService) { }

  ngOnInit() {
    this.loadingMessage = this._i18nService.instant('TRACE.LOADING_FILE');
    this.contentFilter.BlobName = this.trace.Name;
    this.getTraceDetail();
    if (window.innerHeight < 600)
      this.screenHeightStyle = 'content-height-xsmall';
    else if (window.innerHeight >= 600 && window.innerHeight < 768)
      this.screenHeightStyle = 'content-height-small';
    else if (window.innerHeight >= 768 && window.innerHeight < 900)
      this.screenHeightStyle = 'content-height-medium';
    else
      this.screenHeightStyle = 'content-height-large';
  }

  ngAfterViewInit() {
    this.checkOverflowX();
  }

  private checkOverflowX() {
    setTimeout(() => {
      if (this.contentDiv && this.contentDiv.nativeElement) {
        const contentDivElement = this.contentDiv.nativeElement;
        this.isOverflowingX = contentDivElement.scrollWidth > contentDivElement.clientWidth;
      } else {
        this.checkOverflowX();
      }
    }, 100);
  }

  getTraceDetail(currentScrollY: number = 0) {
    this.showLoading = true;
    this._traceService.getTraceDetail(this.contentFilter).subscribe((res: any) => {
      this.contentFile += res.ContentSegment;
      this.contentSize = res.DisplaySize;
      this.sizeDisplayed += this.blockSize;
      this.showLoadMoreResults = this.sizeDisplayed < res.Size;
      this.showLoading = false;
      if (currentScrollY !== 0)
        this.watiForContentLoaded(currentScrollY);
    });
  }

  watiForContentLoaded(currentScrollY: number = 0) {
    if (this.contentDiv && this.contentDiv.nativeElement) 
    {
      this.contentDiv.nativeElement.scrollTop = currentScrollY;
      return;
    }
    else {
      setTimeout(() => {
        this.watiForContentLoaded(currentScrollY);
      }, 100);
    }
  } 

  downloadFile() {
    let fileName = this.trace.DisplayName;
    this.isDownloading = true;
    const downloadFile = [this.trace.Name];
    this._traceService.downloadTraceFile(downloadFile, fileName).subscribe(() => {
      this.isDownloading = false;
    });
  }

  closeModal() {
    this.modalComponentRef.close();
  }

  loadMore() {
    const currentScrollY = this.contentDiv.nativeElement.scrollTop;
    this.loadingMessage = this._i18nService.instant('TRACE.LOADING_FILE');
    this.contentFilter.Start += this.blockSize;
    this.contentFilter.End += this.blockSize;
    this.getTraceDetail(currentScrollY);
  }
}
